import axios from 'axios';

const instance =  axios.create({
    baseURL:'https://mauriciomares.com:3115'
    //baseURL:'http://192.168.1.75:3015'
});

instance.interceptors.request.use(
    async config => {
      const obj = localStorage.getItem("eCommerce_ReactJS_002");
      const item = JSON.parse(obj);

      if (item?.token) {
        config.headers.Authorization = `Bearer ${item.token}`;
      }
      return config;
    },
    err => {
      return Promise.reject(err);
    }
  );

export default instance;